import React, { useState } from 'react';
import { Row, Col, Menu, Button, Spin ,Select} from 'antd';
import { Column } from '@ant-design/plots';
import {
    queryAPIBindUserCountByDate, queryAPIPullCountByMonths,
    queryAPIPushCountByMonths, queryAPIPubSubCountByMonths
} from "./gqls";
import Client from '../../../../lib/gqlClient';
import getWantTimestamp from '../../../../lib/utils/times'
import moment from 'moment-timezone';
const QuantityChartPage = () => {
    const [isSelectAppOrDeveloperLoading, setIsSelectAppOrDeveloperLoading] = useState(false)//是否正在加载
    let isSelectAppOrDeveloper = 1 //1绑定用户数  2Push量  3Pull量  4PubSub量
    const [oneList, setOneList] = useState([])
    const [time, setTime] = useState()
    const [timeList, setTimeList] = useState([{}])
    const [quantityName, setQuantityName] = useState('绑定用户数趋势')
    const [quantityNameItem, setQuantityNameItem] = useState('绑定用户数')
    React.useEffect(() => {
        let year = moment().utc().year();
        setTime(year)
        var list = [{}]
        list[0] = { value: '本季度', label: '本季度' }
        for (let index = 1; index <= year - 2020 + 1; index++) {
            list[index] = { value: year - index + 1, label: year - index + 1 }
        }
        list[year - 2020 + 2] = { value: '全部', label: '全部' }
        setTimeList(list)
        getSelectQuantity(year)

    }, [])
    function onClick(e) {
        console.log(e)
        switch (e.key) {
            case "1":
                //绑定用户数
                isSelectAppOrDeveloper = 1
                getSelectQuantity(time);
                break;
            case "2":
                //Push量
                isSelectAppOrDeveloper = 2
                getSelectQuantity(time);
                break;
            case "3":
                //Pull量
                isSelectAppOrDeveloper = 3
                getSelectQuantity(time);
                break;
            case "4":
                //PubSub量
                isSelectAppOrDeveloper = 4
                getSelectQuantity(time);
                break;
        }
    }
    function btnAppOrDeveloper(type) {
        switch (quantityName) {
            case "绑定用户数趋势":
                isSelectAppOrDeveloper = 1
                break;
            case "Push量趋势":
                isSelectAppOrDeveloper = 2
                break;
            case "Pull量趋势":
                isSelectAppOrDeveloper = 3
                break;
            case "PubSub量趋势":
                isSelectAppOrDeveloper = 4
                break;

        }
        getSelectQuantity(type)
    }
    function getSelectQuantity(type) {
        var start = ''
        var end = ''
        let month = moment().utc().month() + 1;
        let year = moment().utc().year();
        switch (type) {
            case '本季度':
                if(isSelectAppOrDeveloper===1){
                    start = getWantTimestamp("threeMonthDayZero");
                    end = getWantTimestamp("nowData");
                }else{
                    let quarter=''
                    if (month >= 1 && month <= 3) {
                      quarter='01'
                    } else if (month >= 4 && month <= 6) {
                      quarter='04'
                    } else if (month >= 7 && month <= 9) {
                      quarter='07'
                    } else if (month >= 10 && month <= 12) {
                      quarter='10'
                    }
                    start = year+"-"+quarter
                    end = year+"-"+month
                }
                break;
            case '全部':
                if(isSelectAppOrDeveloper===1){
                    start = moment.tz('2020-01-01T00:00:00', 'ETC/GMT+0').valueOf()
                    end = getWantTimestamp("nowData")
                }else{
                    start = "2020-01"
                    end = year+"-"+month
                }
                break;
            default: {
                if(isSelectAppOrDeveloper===1){
                    start = moment.tz(type + '-01-01T00:00:00', 'ETC/GMT+0').valueOf()
                    end = moment.tz(type + '-12-31T23:59:59', 'ETC/GMT+0').valueOf()
                }else{
                    start = type + '-01'
                    end = type + '-12'
                }
            }
        }
        setIsSelectAppOrDeveloperLoading(true)
        switch (isSelectAppOrDeveloper) {
            case 1:
                setQuantityName('绑定用户数趋势')
                setQuantityNameItem('绑定用户数')
                getAPIBindUserCountByDate(type, start, end)
                break;
            case 2:
                setQuantityName('Push量趋势')
                setQuantityNameItem('Push量')
                getAPIPushCountByMonths(type, start, end,)
                break;
            case 3:
                setQuantityName('Pull量趋势')
                setQuantityNameItem('Pull量')
                getAPIPullCountByMonths(type, start, end,)
                break;
            case 4:
                setQuantityName('PubSub量趋势')
                setQuantityNameItem('PubSub量')
                getAPIPubSubCountByMonths(type, start, end,)
                break;

        }

    }

    function getAPIBindUserCountByDate(type, start, end) {
        //默认显示全年 1本月 2本季度 3全年
        isSelectAppOrDeveloper = true
        Client(
            queryAPIBindUserCountByDate,
            {
                startDate: start,
                endDate: end
            }
        ).then((res) => {
            console.log(res)
            if (res !== null) {
                const list = res.data.openAPIBindUserCountByDate
                let data = [{}];
                list.map((item, index) => {
                    data[index] = {
                        type: item.year + "-" + item.month,
                        sales: item.count,
                    }
                })
                setOneList(data)
                setIsSelectAppOrDeveloperLoading(false)
            }
        }).catch(e => {
            setOneList([])
            setIsSelectAppOrDeveloperLoading(false)
        })
    }
    function getAPIPullCountByMonths(type, start, end) {
        //默认显示全年 1本月 2本季度 3全年
        isSelectAppOrDeveloper = true
        Client(
            queryAPIPullCountByMonths,
            {
                start: start,
                end: end
            }
        ).then((res) => {
            console.log(res)
            if (res !== null) {
                const list = res.data.openAPIPullCountByMonths
                let data = [{}];
                list.map((item, index) => {
                    data[index] = {
                        type: item.year + "-" + item.month,
                        sales: item.count,
                    }
                })
                setOneList(data)
                setIsSelectAppOrDeveloperLoading(false)
            }
        }).catch(e => {
            setOneList([])
            setIsSelectAppOrDeveloperLoading(false)
        })
    }
    function getAPIPushCountByMonths(type, start, end) {
        //默认显示全年 1本月 2本季度 3全年
        isSelectAppOrDeveloper = true
        Client(
            queryAPIPushCountByMonths,
            {
                start: start,
                end: end
            }
        ).then((res) => {
            console.log(res)
            if (res !== null) {
                const list = res.data.openAPIPushCountByMonths
                let data = [{}];
                list.map((item, index) => {
                    data[index] = {
                        type: item.year + "-" + item.month,
                        sales: item.count,
                    }
                })
                setOneList(data)
                setIsSelectAppOrDeveloperLoading(false)
            }
        }).catch(e => {
            setOneList([])
            setIsSelectAppOrDeveloperLoading(false)
        })
    }
    function getAPIPubSubCountByMonths(type, start, end) {
        //默认显示全年 1本月 2本季度 3全年
        isSelectAppOrDeveloper = true
        Client(
            queryAPIPubSubCountByMonths,
            {
                start: start,
                end: end
            }
        ).then((res) => {
            console.log(res)
            if (res !== null) {
                const list = res.data.openAPIPubSubCountByMonths
                let data = [{}];
                list.map((item, index) => {
                    data[index] = {
                        type: item.year + "-" + item.month,
                        sales: item.count,
                    }
                })
                setOneList(data)
                setIsSelectAppOrDeveloperLoading(false)
            }
        }).catch(e => {
            setOneList([])
            setIsSelectAppOrDeveloperLoading(false)
        })
    }
    const onItemsMembersClick = (value) => {
        console.log(value)
        setTime(value)
        btnAppOrDeveloper(value)
    };
    return (

        <div style={{ height: '404px', padding: '0px', marginTop: '15px', backgroundColor: 'white', borderRadius: '2px' }}>

            <div style={{ height: '55px', padding: '0px', }}>
                <Row>
                    <Col span={12}>
                        <Menu defaultSelectedKeys={['1']}
                            defaultOpenKeys={['a']}
                            mode="horizontal"
                            style={{ justifyContent: 'start' }}
                            items={itemsOne}
                            onClick={onClick}
                        >
                        </Menu>
                    </Col>
                    <Col span={12} style={{ display: 'flex', justifyContent: 'right', alignItems: 'center', }}>
                    <div style={{
                            marginRight: '18px', width: '200px', minHeight: '30px', borderRadius: "2px", border: '1px solid rgba(0, 0, 0, 0.2)'
                        }}>
                            <Select
                                className='select'
                                size='middle'
                                style={{
                                    width: '200px',
                                }}
                                maxTagCount='responsive'
                                showArrow={true}
                                bordered={false}
                                placeholder="Please select"
                                onSelect={onItemsMembersClick}
                                options={timeList}
                                value={time}
                            />
                        </div>
                    </Col>
                </Row>
                <div style={{ height: '1px', backgroundColor: '#E8E8E8' }} />
            </div>
            <a style={{ marginLeft: '56px', marginTop: '24px', display: 'block', fontSize: '16px', lineHeight: '24px', color: ' #2657F9' }}>{quantityName}</a>
            <Spin size="large" tip="Loading..." spinning={isSelectAppOrDeveloperLoading}>
                <Column {...{
                    data: oneList,
                    xField: 'type',
                    yField: 'sales',
                    color: '#2657F9',
                    columnWidthRatio: 0.4,
                    marginRatio: 0.6,
                    legend: false,
                    minColumnWidth: 30, 
                    xAxis: {
                        label: {
                            autoHide: true,
                            autoRotate: false,
                        },
                    },
                    meta: {
                        sales: {
                            alias: quantityNameItem,
                        },
                    },
                    scrollbar: {
                        type: 'horizontal',
                      },
                }} style={{ height: '246px', marginTop: '20px', marginBottom: '33px', marginLeft: '99px', marginRight: '94px' }} />
            </Spin>

        </div>
    )

}
function getItem(label, key,) {
    return {
        key,
        label,
    };
}
const itemsOne = [
    getItem('绑定用户数', '1'),
    getItem('Push量', '2'),
    getItem('Pull量', '3'),
    getItem('PubSub量', '4'),

];
export default QuantityChartPage